import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

export const initialclauseFilter = {
  clauseFilters: [],
  taxValues: {
    name: "",
    options: [],
  },
};

const initialState = () => {
  return initialclauseFilter;
};

export const clauseFilterSlice = createSlice({
  name: "clauseFilter",
  initialState,
  reducers: {
    handleAddFilters: (state, { payload }) => {
      state.clauseFilters = payload;
    },
    handleRemoveFilterUnic: (state, action) => {
      const { id } = action.payload;
      state.clauseFilters = state.clauseFilters.filter(item => item.id !== id);
    },
    handleOnChangeFilter: (state, { payload }) => {
      const list = [...state.clauseFilters];
      list[payload?.key].columnField[payload?.field] = payload?.value;
      state.clauseFilters = list;
    },
    handleRemoveFilterAll: state => {
      state.clauseFilters = [
        {
          id: uuidv4(),
          columnField: {
            columnOrField: "and",
            columnField: "prod_nome",
            operatorValue: "equals",
            value: "",
          },
        },
      ];
    },
    handleSetOptionsValue: (state, { payload }) => {
      state.taxValues.name = payload.name;
      state.taxValues.options = payload.options;
    },
  },
});

export const {
  handleAddFilters,
  handleRemoveFilterUnic,
  handleOnChangeFilter,
  handleRemoveFilterAll,
  handleSetOptionsValue,
} = clauseFilterSlice.actions;

export default clauseFilterSlice.reducer;
